import React, { useEffect, useMemo, useState } from "react";
import * as S from "./FolderContent.style";

function FolderContent({}){
  
  return(
    <S.FolderContent>
      <div className="empty-content"></div>
    </S.FolderContent>
  )
}

export default FolderContent;
